import router from './router'
import pageTitle from './utils/tools/pagesTitle'

router.beforeEach(async(to, from, next) => {
  document.title = pageTitle(to.meta.title)
  next()
})

